<button type="button" class="height-full" vbUiBtnPrimaryNgx [hidden]="!(templateListCount !== undefined)" [disabled]="isMoreThanOneTemplate && !isTemplateSelected" (click)="approvalSubmit()">
	<span [hidden]="isSubmitted">
		{{ (isMoreThanOneTemplate ? 'UI_Submit' : 'UI_SubmitForApproval') | translate }}
	</span>
	<span [hidden]="!isSubmitted">
		<vb-loading-spinner [size]="'small'"></vb-loading-spinner>
		{{ 'Processing' | translate }}
	</span>
</button>